import {
    dashboardService,
    folderService,
    investmentService,
    listService,
    memoService,
    pipelineService,
} from '@/services';
import { CollaboratorPermissionType, TeamResourceAccessResourceType } from '@/types';

export type WorkspaceResourceOption = {
    id: string;
    label: string;
    type: TeamResourceAccessResourceType;
};

export const resourceTypeOptions = [
    TeamResourceAccessResourceType.FOLDER,
    TeamResourceAccessResourceType.INVESTMENT,
    // Lifecycles remains dormant until the product surface is ready to ship.
    TeamResourceAccessResourceType.MEMO,
    TeamResourceAccessResourceType.PIPELINE,
    TeamResourceAccessResourceType.DASHBOARD,
    TeamResourceAccessResourceType.LIST,
];

export const permissionOptions = [
    CollaboratorPermissionType.VIEW,
    CollaboratorPermissionType.COMMENT,
    CollaboratorPermissionType.EDIT,
    CollaboratorPermissionType.OWNER,
];

function resourceLabel(resource: any, type: TeamResourceAccessResourceType) {
    if (type === TeamResourceAccessResourceType.INVESTMENT) {
        return resource.editedName || resource.name || resource.ticker || resource.id;
    }

    return resource.name || resource.title || resource.editedName || resource.id;
}

export async function loadResources(type: TeamResourceAccessResourceType): Promise<WorkspaceResourceOption[]> {
    const serviceMap = {
        [TeamResourceAccessResourceType.FOLDER]: folderService.list,
        [TeamResourceAccessResourceType.INVESTMENT]: investmentService.list,
        [TeamResourceAccessResourceType.LIFECYCLE]: async () => [],
        [TeamResourceAccessResourceType.MEMO]: memoService.list,
        [TeamResourceAccessResourceType.PIPELINE]: pipelineService.list,
        [TeamResourceAccessResourceType.DASHBOARD]: dashboardService.list,
        [TeamResourceAccessResourceType.LIST]: listService.list,
    };

    const resources = await serviceMap[type]();

    return resources.map((resource: any) => ({
        id: resource.id,
        label: resourceLabel(resource, type),
        type,
    }));
}
